(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aeris-ar-viewer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aeris-ar-viewer')) {
    class AerisARViewer extends HTMLElement {
      static enginePromise = null;

      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.dialog = this.querySelector('dialog');
        this.openButton = this.querySelector('[data-ar-open]');
        this.mount = this.querySelector('[data-ar-mount]');
        this.templates = Array.from(this.querySelectorAll('template[data-ar-model-id]'));
        this.models = JSON.parse(this.querySelector('[data-ar-models]').textContent);
        this.variants = JSON.parse(this.querySelector('[data-ar-variants]')?.textContent || '[]');
        this.currentOptions = JSON.parse(this.dataset.initialOptions || '[]');
        this.variantScope = this.closest('aeris-product, aeris-offer');
        this.syncSelection();
        this.requestId = 0;
        this.openButton.addEventListener('click', () => this.open(), options);
        this.querySelector('[data-ar-close]').addEventListener('click', () => this.dialog.close(), options);
        this.querySelector('[data-ar-retry]').addEventListener('click', () => this.loadModel(true), options);
        this.dialog.addEventListener('close', () => this.onClose(), options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        }, options);
        this.variantScope?.addEventListener('aeris:variant-change', (event) => {
          if (!Array.isArray(event.detail?.variant?.options)) return;
          this.currentOptions = event.detail.variant.options;
          if (this.dialog.open) this.loadModel();
        }, options);
        this.openButton.hidden = false;
        if (this.dataset.designMode !== 'true') {
          window.addEventListener('hashchange', () => this.openFromLink(), options);
          queueMicrotask(() => this.openFromLink());
        }
      }

      disconnectedCallback() {
        if (this.dialog?.open) {
          this.dialog.close();
          this.restoreScroll();
        }
        this.events?.abort();
        this.events = null;
        this.modelEvents?.abort();
        clearTimeout(this.loadTimeout);
        this.requestId += 1;
      }

      open(color) {
        this.syncSelection();
        if (color === 'black' || color === 'white') this.currentOptions = [color];
        if (this.dialog.open) {
          this.loadModel();
          return;
        }
        this.previousFocus = document.activeElement;
        this.previousOverflow = document.body.style.overflow;
        this.dialog.showModal();
        document.body.style.overflow = 'hidden';
        this.loadModel();
        this.setupXR();
      }

      syncSelection() {
        const color = this.variantScope?.dataset.selectedColor;
        if (color === 'black' || color === 'white') this.currentOptions = [color];
      }

      openFromLink() {
        if (!this.isConnected || !this.closest('aeris-product')) return;
        const match = window.location.hash.match(/^#aeris-ar=(black|white)$/);
        if (!match || this.handledHash === window.location.hash) return;
        if (document.querySelector('aeris-product aeris-ar-viewer') !== this) return;
        this.handledHash = window.location.hash;
        this.open(match[1]);
      }

      mobileLink(color) {
        const url = new URL(this.dataset.productUrl);
        if (url.protocol !== 'https:') throw new Error('Expected HTTPS product URL');
        url.search = '';
        url.hash = '';
        const normalize = value => String(value).trim().toLowerCase();
        const variants = this.variants.filter(variant => variant.options.some(option =>
          (color === 'white' ? ['white', 'blanc'] : ['black', 'noir']).includes(normalize(option))));
        const variant = variants.find(item => item.options.length === this.currentOptions.length &&
          item.options.every((option, index) => normalize(option) === normalize(this.currentOptions[index]))) || variants[0];
        if (variant) url.searchParams.set('variant', variant.id);
        url.hash = 'aeris-ar=' + color;
        return url.href;
      }

      updateHandoff(color) {
        const panel = this.querySelector('[data-ar-handoff]');
        if (!panel) return;
        try {
          const url = this.mobileLink(color);
          this.querySelector('[data-ar-mobile-link]').href = url;
          if (this.qrUrl !== url) {
            const qr = AerisARViewer.qrCode(url);
            const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svg.setAttribute('viewBox', qr.viewBox);
            svg.setAttribute('shape-rendering', 'crispEdges');
            const background = document.createElementNS(svg.namespaceURI, 'rect');
            background.setAttribute('width', qr.extent);
            background.setAttribute('height', qr.extent);
            background.setAttribute('fill', '#fff');
            const path = document.createElementNS(svg.namespaceURI, 'path');
            path.setAttribute('d', qr.path);
            path.setAttribute('fill', '#171717');
            svg.append(background, path);
            this.querySelector('[data-ar-qr]').replaceChildren(svg);
            this.qrUrl = url;
          }
          panel.hidden = false;
        } catch (error) {
          panel.hidden = true;
        }
      }

      onClose() {
        this.requestId += 1;
        clearTimeout(this.loadTimeout);
        this.restoreScroll();
        if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
      }

      restoreScroll() {
        if (this.previousOverflow === undefined) return;
        document.body.style.overflow = this.previousOverflow;
        this.previousOverflow = undefined;
      }

      currentTemplate() {
        const white = this.currentOptions.some((option) => ['blanc', 'white'].includes(String(option).trim().toLowerCase()));
        const color = white ? 'white' : 'black';
        return this.templates.find((template) => template.dataset.arColor === color) || this.templates[0];
      }

      setState(state) {
        this.state = state;
        this.setAttribute('data-ar-state', state);
        this.querySelector('[data-ar-stage]').setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
        this.querySelector('[data-ar-loading]').hidden = state !== 'loading';
        this.querySelector('[data-ar-error]').hidden = state !== 'error';
        this.mount.hidden = state === 'error';
        this.querySelectorAll('[data-ar-xr-for]').forEach((wrapper) => {
          wrapper.hidden = state !== 'ready' || wrapper.dataset.arXrFor !== this.activeModelId;
        });
      }

      async loadModel(force = false) {
        const template = this.currentTemplate();
        if (!template) return;
        const id = template.dataset.arModelId;
        this.updateHandoff(template.dataset.arColor);
        this.querySelector('[data-ar-finish]').textContent = template.dataset.arColor === 'white' ? this.dataset.whiteLabel : this.dataset.blackLabel;
        if (!force && id === this.activeModelId && this.viewer?.loaded) {
          this.setState('ready');
          return;
        }
        const requestId = ++this.requestId;
        this.activeModelId = id;
        this.modelEvents?.abort();
        clearTimeout(this.loadTimeout);
        this.mount.replaceChildren();
        this.setState('loading');
        this.loadTimeout = setTimeout(() => {
          if (requestId === this.requestId && this.dialog.open) {
            this.requestId += 1;
            this.setState('error');
          }
        }, 60000);
        try {
          this.modelEvents = new AbortController();
          const options = { signal: this.modelEvents.signal, once: true };
          const content = template.content.cloneNode(true);
          this.viewer = content.querySelector('model-viewer');
          if (!this.viewer) throw new Error('Missing model viewer');
          if (template.dataset.arAlt) this.viewer.setAttribute('alt', template.dataset.arAlt);
          this.viewer.addEventListener('load', () => {
            if (requestId !== this.requestId) return;
            clearTimeout(this.loadTimeout);
            this.setState('ready');
          }, options);
          this.viewer.addEventListener('error', () => {
            if (requestId !== this.requestId) return;
            clearTimeout(this.loadTimeout);
            this.setState('error');
          }, options);
          this.mount.append(content);
          await AerisARViewer.loadEngine();
          if (requestId !== this.requestId || !this.isConnected || !this.dialog.open) return;
          if (this.viewer.loaded) {
            clearTimeout(this.loadTimeout);
            this.setState('ready');
          }
        } catch (error) {
          if (requestId !== this.requestId) return;
          clearTimeout(this.loadTimeout);
          this.setState('error');
        }
      }

      static qrCode(text) {
        if (typeof text !== 'string' || text.length > 106 || /[^\x20-\x7e]/.test(text)) {
          throw new RangeError('QR input must contain at most 106 printable ASCII bytes.');
        }
        const size = 37;
        const quietZone = 4;
        const dataCount = 108;
        const eccCount = 26;
        const bits = [];
        const append = (value, count) => {
          for (let shift = count - 1; shift >= 0; shift -= 1) bits.push((value >>> shift) & 1);
        };
        append(4, 4);
        append(text.length, 8);
        for (let i = 0; i < text.length; i += 1) append(text.charCodeAt(i), 8);
        append(0, Math.min(4, dataCount * 8 - bits.length));
        while (bits.length % 8) bits.push(0);
        const data = [];
        for (let i = 0; i < bits.length; i += 8) {
          let value = 0;
          for (let j = 0; j < 8; j += 1) value = (value << 1) | bits[i + j];
          data.push(value);
        }
        for (let pad = 0; data.length < dataCount; pad += 1) data.push(pad % 2 ? 0x11 : 0xec);
      
        const powers = new Uint8Array(512);
        const logs = new Uint8Array(256);
        let field = 1;
        for (let i = 0; i < 255; i += 1) {
          powers[i] = field;
          logs[field] = i;
          field <<= 1;
          if (field & 0x100) field ^= 0x11d;
        }
        for (let i = 255; i < powers.length; i += 1) powers[i] = powers[i - 255];
        const multiply = (a, b) => a && b ? powers[logs[a] + logs[b]] : 0;
        let generator = [1];
        for (let degree = 0; degree < eccCount; degree += 1) {
          const next = new Array(generator.length + 1).fill(0);
          for (let i = 0; i < generator.length; i += 1) {
            next[i] ^= generator[i];
            next[i + 1] ^= multiply(generator[i], powers[degree]);
          }
          generator = next;
        }
        const remainder = new Array(eccCount).fill(0);
        for (const byte of data) {
          const factor = byte ^ remainder.shift();
          remainder.push(0);
          for (let i = 0; i < eccCount; i += 1) remainder[i] ^= multiply(generator[i + 1], factor);
        }
        const codewords = data.concat(remainder);
        const matrix = Array.from({ length: size }, () => new Array(size).fill(false));
        const reserved = Array.from({ length: size }, () => new Array(size).fill(false));
        const mark = (x, y, dark) => {
          if (x < 0 || x >= size || y < 0 || y >= size) return;
          matrix[y][x] = Boolean(dark);
          reserved[y][x] = true;
        };
        for (let i = 0; i < size; i += 1) {
          mark(6, i, i % 2 === 0);
          mark(i, 6, i % 2 === 0);
        }
        for (const [cx, cy] of [[3, 3], [size - 4, 3], [3, size - 4]]) {
          for (let dy = -4; dy <= 4; dy += 1) {
            for (let dx = -4; dx <= 4; dx += 1) {
              const distance = Math.max(Math.abs(dx), Math.abs(dy));
              mark(cx + dx, cy + dy, distance !== 2 && distance !== 4);
            }
          }
        }
        for (let dy = -2; dy <= 2; dy += 1) {
          for (let dx = -2; dx <= 2; dx += 1) {
            mark(30 + dx, 30 + dy, Math.max(Math.abs(dx), Math.abs(dy)) !== 1);
          }
        }
        const formatData = 8;
        let formatRemainder = formatData;
        for (let i = 0; i < 10; i += 1) formatRemainder = (formatRemainder << 1) ^ ((formatRemainder >>> 9) * 0x537);
        const format = ((formatData << 10) | formatRemainder) ^ 0x5412;
        const formatBit = (index) => (format >>> index) & 1;
        for (let i = 0; i < 6; i += 1) mark(8, i, formatBit(i));
        mark(8, 7, formatBit(6));
        mark(8, 8, formatBit(7));
        mark(7, 8, formatBit(8));
        for (let i = 9; i < 15; i += 1) mark(14 - i, 8, formatBit(i));
        for (let i = 0; i < 8; i += 1) mark(size - 1 - i, 8, formatBit(i));
        for (let i = 8; i < 15; i += 1) mark(8, size - 15 + i, formatBit(i));
        mark(8, size - 8, true);
      
        let bitIndex = 0;
        for (let right = size - 1; right > 0; right -= 2) {
          if (right === 6) right = 5;
          for (let step = 0; step < size; step += 1) {
            const upward = ((right + 1) & 2) === 0;
            const y = upward ? size - 1 - step : step;
            for (let offset = 0; offset < 2; offset += 1) {
              const x = right - offset;
              if (reserved[y][x]) continue;
              const value = bitIndex < codewords.length * 8 ? (codewords[bitIndex >>> 3] >>> (7 - (bitIndex & 7))) & 1 : 0;
              matrix[y][x] = Boolean(value ^ ((x + y) % 2 === 0 ? 1 : 0));
              bitIndex += 1;
            }
          }
        }
        if (bitIndex !== 1079) throw new Error('Unexpected QR module layout.');
        const segments = [];
        for (let y = 0; y < size; y += 1) {
          for (let x = 0; x < size; x += 1) {
            if (!matrix[y][x]) continue;
            const start = x;
            while (x + 1 < size && matrix[y][x + 1]) x += 1;
            const length = x - start + 1;
            segments.push(`M${start + quietZone} ${y + quietZone}h${length}v1h-${length}z`);
          }
        }
        const path = segments.join('');
        const extent = size + quietZone * 2;
        const viewBox = `0 0 ${extent} ${extent}`;
        const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="180" height="180" viewBox="${viewBox}" shape-rendering="crispEdges"><rect width="${extent}" height="${extent}" fill="#fff"/><path d="${path}" fill="#111"/></svg>`;
        return { version: 5, level: 'L', mask: 0, size, quietZone, extent, viewBox, matrix, path, svg };
      }

      static loadEngine() {
        if (customElements.get('model-viewer')) return Promise.resolve();
        if (!this.enginePromise) {
          this.enginePromise = new Promise((resolve, reject) => {
            const timeout = setTimeout(() => reject(new Error('3D engine timed out')), 20000);
            const complete = (error) => {
              if (error) {
                clearTimeout(timeout);
                reject(error);
                return;
              }
              customElements.whenDefined('model-viewer').then(() => {
                clearTimeout(timeout);
                resolve();
              });
            };
            if (!window.Shopify?.loadFeatures) {
              clearTimeout(timeout);
              reject(new Error('Shopify loader unavailable'));
              return;
            }
            window.Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0', onLoad: complete }]);
          }).catch((error) => {
            this.enginePromise = null;
            throw error;
          });
        }
        return this.enginePromise;
      }

      setupXR() {
        if (this.xrReady || this.xrLoading || !window.Shopify?.loadFeatures) return;
        this.xrLoading = true;
        const register = () => {
          if (!this.isConnected || this.xrReady) return;
          if (!window.ShopifyXR) {
            document.addEventListener('shopify_xr_initialized', register, { once: true, signal: this.events.signal });
            return;
          }
          window.ShopifyXR.addModels(this.models);
          window.ShopifyXR.setupXRElements();
          this.xrReady = true;
          this.xrLoading = false;
        };
        window.Shopify.loadFeatures([{
          name: 'shopify-xr',
          version: '1.0',
          onLoad: (errors) => {
            if (errors) {
              this.xrLoading = false;
              return;
            }
            register();
          }
        }]);
      }
    }
    customElements.define('aeris-ar-viewer', AerisARViewer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aeris-cart-set-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aeris-cart-set-offer')) {
    class AerisCartSetOffer extends HTMLElement {
      static pending = false;

      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.button = this.querySelector('button');
        this.status = this.querySelector('[role="status"]');
        this.refresh = this.querySelector('a');
        this.button.addEventListener('click', () => this.upgrade());
        this.hidden = false;
      }

      static isPlainItem(item) {
        return Object.keys(item.properties || {}).length === 0 &&
          !item.selling_plan_allocation && !item.parent_relationship && !item.has_components &&
          !item.item_components?.length && !item.line_level_discount_allocations?.length;
      }

      static buildUpdates(cart, product, data) {
        if (cart.cart_level_discount_applications?.length) return null;
        const singleId = Number(data.singleId);
        const setId = Number(data.setId);
        const lines = cart.items.filter(item => item.variant_id === singleId);
        const item = lines[0];
        const variant = product.variants.find(entry => entry.id === setId);
        if (lines.length !== 1 || !item || item.key !== data.lineKey ||
          item.sku !== data.singleSku || item.quantity !== Number(data.quantity) || item.quantity < 2 ||
          !AerisCartSetOffer.isPlainItem(item) || item.final_price !== item.original_price ||
          item.final_price !== Number(data.singlePrice) ||
          cart.items.some(entry => entry.variant_id === setId) ||
          !variant?.available || variant.sku !== data.setSku || variant.price !== Number(data.setPrice) ||
          variant.price >= item.final_price * 2) return null;
        return { [item.key]: item.quantity - 2, [setId]: 1 };
      }

      async readJSON(url, options = {}) {
        const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', ...options });
        const data = await response.json();
        if (!response.ok || data.errors || data.status >= 400) throw new Error('cart-set-request');
        return data;
      }

      async upgrade() {
        if (AerisCartSetOffer.pending || this.button.disabled) return;
        AerisCartSetOffer.pending = true;
        this.button.disabled = true;
        this.setAttribute('aria-busy', 'true');
        this.status.textContent = this.dataset.busy;
        const locked = [];
        try {
          const quantities = document.querySelectorAll('cart-items input[name="updates[]"], cart-drawer-items input[name="updates[]"]');
          const quantityPending = [...quantities].some(input => input.value !== input.getAttribute('value'));
          if (quantityPending || document.querySelector('.cart__items--disabled')) throw new Error('pending-cart');
          for (const element of document.querySelectorAll('cart-items, cart-drawer-items, .cart__ctas, .cart__dynamic-checkout-buttons')) {
            locked.push([element, element.inert]);
            element.inert = true;
          }
          const [cart, product] = await Promise.all([
            this.readJSON(this.dataset.cartUrl + '.js'),
            this.readJSON(this.dataset.productUrl + '.js')
          ]);
          const updates = AerisCartSetOffer.buildUpdates(cart, product, this.dataset);
          if (!updates || !this.isConnected) throw new Error('changed-cart');
          const result = await this.readJSON(this.dataset.updateUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates })
          });
          const singles = result.items.filter(item => item.variant_id === Number(this.dataset.singleId));
          const sets = result.items.filter(item => item.variant_id === Number(this.dataset.setId));
          if (singles.reduce((sum, item) => sum + item.quantity, 0) !== Number(this.dataset.quantity) - 2 ||
            sets.reduce((sum, item) => sum + item.quantity, 0) !== 1) throw new Error('unconfirmed-cart');
          window.location.assign(this.dataset.cartUrl);
        } catch {
          this.status.textContent = this.dataset.error;
          this.refresh.hidden = false;
          this.refresh.focus();
        } finally {
          for (const [element, wasInert] of locked) element.inert = wasInert;
          this.removeAttribute('aria-busy');
          AerisCartSetOffer.pending = false;
        }
      }
    }
    customElements.define('aeris-cart-set-offer', AerisCartSetOffer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aeris-native-consent-style"] && !Shopify.designMode) return;
  try {
    (() => {
    const normalizeBannerTitle = () => {
      const title = document.querySelector('#shopify-pc__banner h2#shopify-pc__banner__body-title');
      if (!title) return;
      const label = document.createElement('p');
      for (const attribute of title.attributes) label.setAttribute(attribute.name, attribute.value);
      label.textContent = title.textContent;
      title.replaceWith(label);
    };
    const initialize = () => {
      normalizeBannerTitle();
      const observer = new MutationObserver((records) => {
        if (records.some((record) => Array.from(record.addedNodes).some((node) =>
          node.nodeType === 1 && (node.id === 'shopify-pc__banner' || node.querySelector?.('#shopify-pc__banner'))
        ))) normalizeBannerTitle();
      });
      observer.observe(document.body, { childList: true });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
  })();
  } catch(e) { console.error(e); }
})();

})();
